export function itemsWidthClass(width: string, image: boolean): string {
    switch (width) {
        case '25':
            return 'w-full md:w-[calc(50%-12px)] lg:w-[calc(25%-18px)]';
        case '33':
            return 'w-full lg:w-[calc((100%/3)-16px)]';
        case '50':
            return 'w-full lg:w-[calc(50%-12px)]';
        case '100':
            if (image) {
                return 'w-full lg:flex lg:flex-row items-center';
            } else {
                return 'w-full lg:flex lg:flex-row items-center justify-center';
            }
        default:
            if (image) {
                return 'w-full lg:flex lg:flex-row items-center';
            } else {
                return 'w-full lg:flex lg:flex-row items-center justify-center';
            }
    }
}

export function contentPaddingClass(width: string, image: boolean): string {
    switch (width) {
        case '25':
            return 'lg:p-8 xl:p-6';
        case '33':
            return 'md:p-10 lg:p-8';
        case '50':
            return 'md:p-8 xl:p-12';
        case '100':
            if (image) {
                return 'md:p-10 xl:py-14 xl:px-20';
            } else {
                return 'md:p-10 xl:py-14 xl:px-0';
            }
        default:
            return 'p-6';
    }
}

export function imageFlexClass(
    width: string,
    image: boolean,
    position: string = 'left'
): string {
    let roundedClass = 'lg:rounded-r-none lg:rounded-l-2xl';
    if (position === 'right') {
        roundedClass = 'lg:rounded-l-none lg:rounded-r-2xl';
    }

    if (image) {
        return width === '100' || width === ''
            ? 'lg:basis-6/12 ' + roundedClass
            : 'rounded-t-2xl';
    } else {
        return width === '100' || width === ''
            ? 'lg:basis-12/12 max-w-[616px] my-0 mx-auto ' + roundedClass
            : 'rounded-t-2xl';
    }
}

export function contentTextAlign(align: string): string {
    switch (align) {
        case 'left':
            return 'text-left';
        case 'center':
            return 'text-center';
        case 'right':
            return 'text-right';
        default:
            return 'text-left';
    }
}

export function getIconColors(
    item: 'background' | 'text',
    colorScheme: string
): string {
    const colors: { [key: string]: { background: string; text: string } } = {
        red_white: {
            background: 'bg-red-300',
            text: 'text-white',
        },
        black_white: {
            background: 'bg-black',
            text: 'text-white',
        },
        white_red: {
            background: 'bg-white',
            text: 'text-red-300',
        },
        white_black: {
            background: 'bg-white',
            text: 'text-black',
        },
        grey_black: {
            background: 'bg-grey-50',
            text: 'text-black',
        },
    };

    const defaultColorScheme = 'black_white';
    const selectedScheme = colors[colorScheme] ?? colors[defaultColorScheme]!;

    return selectedScheme[item];
}

export function imageOverlayClass(needOverlay: boolean) {
    return needOverlay ? 'brightness-50' : '';
}
